import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_containers/packing_house_process/${packing_house_process_id}`
    );
  },

  fetchContainers(packing_house_id, packing_house_process_id, filters = {}) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_containers/${packing_house_process_id}`,
      { params: filters }
    );
  },

  fetchExporterQualityTemplates(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/quality_control/query_container/${packing_house_id}/list_containers/list_quality_templates/${packing_house_process_id}`
    );
  }
};
